import React, { ChangeEvent, FunctionComponent } from 'react';
import { Controller } from 'react-hook-form';

import { FormGroup } from 'components/chroma';
import { OptionGroup, Select } from 'components/chroma/extended';

import {
  SelectQuestionProps,
  SelectOption,
  SelectOptionGroup,
} from 'scenes/common/components/Questions/types';

const SelectQuestion: FunctionComponent<SelectQuestionProps> = ({
  control,
  isLoading,
  question,
  stateKey,
  ariaLabel,
  defaultValue,
  required,
  options,
  helpText,
  helpLink,
  changeHandler,
  ariaRequired,
}) => {
  const rules =
    required === false
      ? undefined
      : {
          required: 'true',
        };
  return (
    <FormGroup
      id={stateKey}
      label={question}
      helpText={helpText || ''}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(helpLink && { helpLink })}
    >
      <Controller
        control={control}
        name={stateKey}
        defaultValue={defaultValue}
        rules={rules}
        render={({ onChange, value }) => (
          <Select
            id={stateKey}
            value={value}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              changeHandler ? changeHandler(event, onChange) : onChange(event)
            }
            fieldName={stateKey}
            isLoading={isLoading}
            ariaLabel={ariaLabel}
            valid={Boolean(value)}
            required={required}
            ariaRequired={ariaRequired}
          >
            {!isLoading && (
              <>
                <option value="">Select</option>
                {options.map((option) => {
                  if ((option as SelectOptionGroup).optionList) {
                    const { label, optionList } = option as SelectOptionGroup;
                    return (
                      <OptionGroup
                        key={label}
                        label={label}
                        optionList={optionList}
                      />
                    );
                  }

                  const { label, value: optionValue } = option as SelectOption;

                  return (
                    <option
                      key={label}
                      className="c-select__option"
                      value={optionValue}
                    >
                      {label}
                    </option>
                  );
                })}
              </>
            )}
          </Select>
        )}
      />
    </FormGroup>
  );
};

export default SelectQuestion;
